'use strict';

function validateRoutes(Routes) {
  for (let i = 0; i < Routes.length; i += 1) {
    if (typeof Routes[i].path !== 'string') throw new TypeError('No path defined for passed route.');
    if (Routes[i].path[0] !== '/' && Routes[i].path[0] !== '*') throw new TypeError('A route path must be with a \'/\'');
    Routes[i].service = new Routes[i].service(Routes[i].path);
  }
  return Routes;
}

module.exports = {
  validateRoutes
}



// WEBPACK FOOTER //
// ../autor/src/validate.js